import React from "react";
import { Route } from "react-router-dom";
import { StartPage } from "./pages/start-page/start-page";
import { YourBirthdatePage } from "./pages/your-birthdate/your-birthdate";
import { YourBirthPlacePage } from "./pages/your-birthplace/your-birthplace";
import { YourBirthTimePage } from "./pages/your-birthtime/your-birthtime";
import { YourGenderPage } from "./pages/your-gender/your-gender";
import { ResultPage } from "./pages/result/result";
import { ZodiacPage } from "./pages/zodiac/zodiac";
import { RelationshipStatusPage } from "./pages/relationship-status/relationship-status";
import { AscpectPage } from "./pages/aspect/aspect";
import { WhatDrivesYouPage } from "./pages/what-drives-you/what-drives-you";
import { ElementOfNaturePage } from "./pages/element-of-nature/element-of-nature";
import { TraitsPage } from "./pages/traits/traits";
import { PrepareHoroscopePage } from "./pages/prepare-horoscope/prepare-horoscope";

const routes = [
  <Route key={0} index element={<StartPage />} />,
  <Route key={1} path="your-birthdate" element={<YourBirthdatePage />} />,
  <Route key={2} path="your-birthplace" element={<YourBirthPlacePage />} />,
  <Route key={3} path="your-birthtime" element={<YourBirthTimePage />} />,
  <Route key={4} path="your-zodiac" element={<ZodiacPage />} />,
  <Route key={5} path="your-gender" element={<YourGenderPage />} />,
  <Route key={6} path="result" element={<ResultPage />} />,
  <Route
    key={7} path="your-zodiac"
    element={<ZodiacPage nextPageLink="../partner-name" />}
  />,
  <Route key={8} path="relationship-status" element={<RelationshipStatusPage />} />,
  <Route key={9} path="aspect" element={<AscpectPage />} />,
  <Route key={10} path="what-drives-you" element={<WhatDrivesYouPage />} />,
  <Route key={11} path="element-of-nature" element={<ElementOfNaturePage />} />,
  <Route key={12} path="traits" element={<TraitsPage />} />,
  <Route key={13} path="horoscope-preparing" element={<PrepareHoroscopePage />} />,
];

export { routes };
